import _ from 'underscore';
import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";
import earning from './preview/index.vue'

var moment = require('moment'); 


export default {
	name: 'earnings',
	props: {
		scroll : Number
	},

	components : {
		earning
	},

	data : function(){

		return {
			loading : false,
			error : null,

			today : new Date(),
			todayInd : new Date(),

			earnings : []

			//start : f.date.addDays(new Date(), -31),
			//end : new Date()

		}

	},

	created() {
		
	},

	destroyed() {
	},

	watch: {
		tscrolly : function(){

			if (this.$refs['list']){

				if (this.$refs['list'].height() - 1000 < this.tscrolly + this.dheight){
					this.$refs['list'].next()
				}
				
			}
			
		},

		todayInd : {
			immediate : true,
			handler : function(){
				this.load()
			}
		}
	},
	computed: mapState({

		start : function(){
			return moment(this.todayInd).startOf('month');
		},
		end : function(){
			return moment(this.todayInd).endOf('month');
		},

		completedPeriod : function(){
			return this.today.getTime() > this.end.unix() * 1000
		},

		periodLabel : function(){
			return f.date.getLocalizedMonthYear(this.todayInd)
		},

		dheight: state => state.dheight,
		tscrolly : function(state){
			return this.scroll || state.tscrolly
		},
		auth : state => state.auth,
		userinfo : state => state.userinfo?.userinfo,

		api : function(){
			if(this.userinfo.type == '4'){
				return 'payments.promo.codeusage'
			}

			if(this.userinfo.type == '2' || this.userinfo.type == '8'){
				return 'team.promo.codeusage'
			}
			

			return ''
		},
		groupping : function(){

			if(this.userinfo.type == '2' || this.userinfo.type == '8'){
				return 'owner'
			}

			return 'code'
			
		},

		group : function(){
			return f.group(this.earnings, (e) => {
				return e[this.groupping]
			})
		},

		totalSummary : function(){
			return this.groupSummary(this.earnings || [])
		},

		parameters : function(){
			return f.deep(this.core, 'appInfo.promo') || {}
		},

		minsumcur : function(){

			if(!this.parameters.reward) return null

			var vkey = 'usd'

			if(this.locale == 'ru'){ vkey = 'rub' }

			if(!this.parameters.reward.min[vkey]) return null

			return {
				value : this.parameters.reward.min[vkey],
				currency : vkey,
				period : this.parameters.reward.period
			}
			
		},

		locale : function(){
			return (this.core.user.locale || "en").split('-')[0]
		}
		
	}),

	methods : {
		nextPeriod : function(){
			this.todayInd = f.date.addOneMonth(this.todayInd)
		},
		prevPeriod : function(){
			this.todayInd = f.date.removeOneMonth(this.todayInd)
		},
		loadF : function(){

			if(!this.api) return Promise.reject('api')

			var r = f.deep(this.core.api, this.api)

			if(!r) return Promise.reject('api')

			return r({
				start : this.start,
				end : this.end
			})
		},

		groupSummary : function(items){

			var bycurrency = f.group(items, (i) => {
				return i.currency
			})

			var result = {}

			_.each(bycurrency, (items, currency) => {
				result[currency] =  (_.reduce(items, (m, i) => {
					return m + i.reward
				}, 0) / 100)
			})


			return result
		},	

		load : function(){

			this.loading = true

			this.loadF().then((d) => {
				this.earnings = d
				this.error = null

				return Promise.resolve()
			}).catch(e => {
				this.error = e

				return Promise.resolve()

			}).finally(() => {
				this.loading = false
			})

		}
	},
}